import { NgModule  } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
//import { RouterModule } from '@angular/router';

import { ManualReviewComponent } from './manual-review.component';

@NgModule({
    imports: [ FormsModule, CommonModule],
    declarations: [ ManualReviewComponent ],
    exports: [ ManualReviewComponent ]
})

export class ManualReviewModule {}
